import BaseAccountController from '../../lib/controllers/BaseAccountController';

export default class EditPasswordController extends BaseAccountController {
	public static $inject: string[] = ['$scope', 'UserResource', 'UserPasswordResource'];

	public oldPassword: string;
	public newPassword: string;
	public newPasswordConfirmation: string;
	public updateFailed: boolean;
	public updateSuccessful: boolean;
	public username: string;

	private readonly User: MyAccountApi.IUserResource;
	private readonly UserPassword: MyAccountApi.IUserPasswordResource;

	constructor($scope: ng.IScope, User: MyAccountApi.IUserResource, UserPassword: MyAccountApi.IUserPasswordResource) {
		super($scope);

		this.User = User;
		this.UserPassword = UserPassword;
	}

	public updatePassword(form: ng.IFormController): void {
		this.updateFailed = false;
		this.updateSuccessful = false;

		if (!form.$invalid) {
			this.oldPassword = $.trim(this.oldPassword);
			this.UserPassword.save({ oldPassword: this.oldPassword, newPassword: this.newPassword }, () => {
				this.updateSuccessful = true;
			}, () => {
				this.updateFailed = true;
			});
		}
	}

	public validateConfirmPassword(ctrl: ng.INgModelController): void {
		ctrl.$setValidity('matchesPassword', this.newPassword === this.newPasswordConfirmation);
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		this.User.get((user: MyAccountApi.IUser) => {
			this.username = user.username;
		});
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}
}
